import { Serializable } from '@core/models';
import { MenuEngineeringProfitability } from './menuEngineeringProfitability';

export class PeriodEngineeringProfitability extends Serializable {
  constructor(periodGuid, menuProfitabilityList) {
    super();
    this.periodGuid = periodGuid || null;
    this.menuProfitabilityList = menuProfitabilityList || [];
  }

  static toInstance(props = {}) {
    const menuProfitabilityList = MenuEngineeringProfitability.toInstanceList(props.menu_profitability_list);
    return new PeriodEngineeringProfitability(props.period_guid, menuProfitabilityList);
  }

  getMenuProfitability(menuGuid) {
    return this.menuProfitabilityList.find((m) => m.menuGuid === menuGuid);
  }

  getSectionProfitability(menuGuid, sectionGuid) {
    const menuEngineeringProfitability = this.getMenuProfitability(menuGuid);
    if (!menuEngineeringProfitability) return undefined;
    return menuEngineeringProfitability.getSectionProfitability(sectionGuid);
  }

  getSectionProfitabilities(menuGuid, sectionGuids) {
    const menuEngineeringProfitability = this.getMenuProfitability(menuGuid);
    if (!menuEngineeringProfitability) return undefined;
    return menuEngineeringProfitability.getSectionProfitabilities(sectionGuids);
  }

  updateMenuProfitability(newPeriodEngineeringProfitability, targetMenuGuid) {
    const updatedMenuProfitability = newPeriodEngineeringProfitability.getMenuProfitability(targetMenuGuid);
    const index = this.menuProfitabilityList.findIndex((m) => (m.menuGuid === targetMenuGuid));
    this.menuProfitabilityList.splice(index, 1, updatedMenuProfitability);
  }

  updateSectionProfitabilities(newPeriodEngineeringProfitability, targetMenuGuid, targetSectionGuids) {
    // Get current and new profitabilities
    const menuEngineeringProfitability = this.getMenuProfitability(targetMenuGuid);
    const updatedMenuProfitability = newPeriodEngineeringProfitability.getMenuProfitability(targetMenuGuid);
    if (menuEngineeringProfitability && updatedMenuProfitability) {
      // get profitabilities of sections
      const updatedSections = updatedMenuProfitability.getSectionProfitabilities(targetSectionGuids);
      // Update section profitabilities
      updatedSections.forEach((updatedSection) => {
        menuEngineeringProfitability.updateSectionProfitability(updatedSection, updatedSection.sectionGuid);
      });
    }
  }
}
